import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.scss']
})
export class AccountSettingsDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
